import React, { useState } from 'react';
import { 
  Box, 
  Typography, 
  Select, 
  MenuItem,
  Button,
  Divider
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CreateGroupDialog from './CreateGroupDialog';

export default function GroupSelector({ 
  groups, 
  currentGroup, 
  onGroupChange,
  refreshGroups
}) {
  const [openCreateGroup, setOpenCreateGroup] = useState(false);

  const handleGroupCreated = async (newGroup) => {
    try {
      await refreshGroups(newGroup.id);
      setOpenCreateGroup(false);
    } catch (error) {
      console.error('Error refreshing groups:', error);
    }
  };

  return (
    <Box>
      <Select
        value={currentGroup}
        onChange={(e) => onGroupChange(e.target.value)}
        fullWidth
        sx={{ mb: 1 }}
      >
        {groups.map(({ id, groupName }) => (
          <MenuItem key={id} value={id}>
            {groupName}
          </MenuItem>
        ))}
      </Select>
      <Button
        startIcon={<AddIcon />}
        onClick={() => setOpenCreateGroup(true)}
        fullWidth
        variant="outlined"
        size="small"
      >
        Create New Group
      </Button>

      <CreateGroupDialog 
        open={openCreateGroup}
        onClose={() => setOpenCreateGroup(false)}
        onGroupCreated={handleGroupCreated}
      />
    </Box>
  );
} 